// Table component styling
const table = {
  styleOverrides: {
    root: {
      fontFamily: "'Inter', 'Roboto', 'Helvetica', 'Arial', sans-serif",
      fontSize: '0.875rem',
      backgroundColor: '#e6f0f0',
      borderRadius: '4px',
      "& .MuiTableCell-root": {
        color: '#333',
        fontFamily: "'Inter', 'Roboto', 'Helvetica', 'Arial', sans-serif",
        fontSize: '0.875rem',
      },
    },
  },
};

// TableHead component styling
const tableHead = {
  styleOverrides: {
    root: {
      backgroundColor: '#064d51',
      "& .MuiTableCell-head": {
        color: 'white',
        fontWeight: 600,
        fontFamily: "'Inter', 'Roboto', 'Helvetica', 'Arial', sans-serif",
        fontSize: '0.875rem',
      },
    },
  },
};

// TableCell component styling
const tableCell = {
  styleOverrides: {
    root: {
      fontFamily: "'Inter', 'Roboto', 'Helvetica', 'Arial', sans-serif",
      fontSize: '0.875rem',
      color: '#333',
    },
    head: {
      color: 'white',
      fontWeight: 600,
    },
  },
};

// TableContainer component styling
const tableContainer = {
  styleOverrides: {
    root: {
      backgroundColor: '#e6f0f0',
      borderRadius: '4px',
    },
  },
};

export { table, tableHead, tableCell, tableContainer };
